// i18next-extract-mark-ns-start OrderSummary
import React from 'react';
import PropTypes from 'prop-types';
import {
  getTotal, getTotalPaid, getTotalClothes, getMinOrderAmountFee, getTotalPaidBrand,
} from 'tilli-core/dist/services/orderPrice';
import { withTranslation } from 'gatsby-plugin-react-i18next';

import withOrderContext from '../../withOrderContext';
import withCustomerContext from '../../withCustomerContext';
import withNavigation from '../../hoc/withNavigation';
import { navigate } from '../../services/navigation';
import callApi from '../../services/api';
import routesMap from '../../Routes';
import { pushToLayer } from '../../services/googleTagManager';
import OrderSummary from './OrderSummary';
import getPreFilledClothes from './preFilledClothes';
import {
  formatClothForSummary,
} from './orderSummaryContainerHelpers';

class OrderSummaryContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      promoCode: {
        code: '',
      },
      hasPromoCode: false,
      errorPromoCode: false,
      isPromoCodeDisplayed: true,
    };
    this.setHasPromoCode = this.setHasPromoCode.bind(this);
    this.checkPromoCode = this.checkPromoCode.bind(this);
    this.setEditingClothIndex = this.setEditingClothIndex.bind(this);
    this.setInputPromoCode = this.setInputPromoCode.bind(this);
  }

  componentDidMount() {
    const { t } = this.props;
    const { preFilledStep, orderContext: { promoCode, addOrEditCloth, country }, isAdviceOrder } = this.props;
    if (promoCode?.code) {
      if (promoCode.code === 'TILLI_ONE_HOUR_ADVICE_29042020' && !isAdviceOrder) {
        this.setInputPromoCode('');
      } else {
        this.setHasPromoCode();
        this.checkPromoCode(promoCode.code);
        if ([
          'CLACDESDOIGTS_17052019',
          'TILLI_ONE_HOUR_ADVICE_29042020',
          'MDLO_LP_20230103',
        ].includes(promoCode.code)) this.setIsPromoCodeDisplayed(false);
      }
    }
    if (preFilledStep?.preFilledCloth) {
      const preFilledClothes = getPreFilledClothes(t, country);
      addOrEditCloth(preFilledClothes[preFilledStep.preFilledCloth]);
      this.checkPromoCode('TOUT_SE_TRANSFORME');
    }
  }

  setIsPromoCodeDisplayed(isPromoCodeDisplayed) {
    this.setState({ isPromoCodeDisplayed });
  }

  setHasPromoCode() {
    this.setState({ hasPromoCode: true });
  }

  setEditingClothIndex(index) {
    const {
      saveCloth, orderContext: { setEditingClothIndex }, setEditingCloth, closeModal,
    } = this.props;
    saveCloth();
    setEditingClothIndex(index, setEditingCloth);
    navigate(routesMap.Step1.url);
    closeModal(false);
  }

  setInputPromoCode(code) {
    const { promoCode: promoCodeState } = this.state;
    let promoCode = { ...promoCodeState };
    if (typeof code === 'string') {
      promoCode.code = code;
    } else {
      promoCode = code;
    }
    this.setState({ promoCode });
  }

  // eslint-disable-next-line class-methods-use-this
  getFormattedClothes(order) {
    let formattedClothes = [];
    formattedClothes = order.clothes.map(formatClothForSummary);
    return formattedClothes;
  }

  getDiscountVouchers() {
    const {
      customerContext: { customer = {} },
    } = this.props;
    const { discountVouchers } = customer;

    return discountVouchers?.length > 0
      ? discountVouchers
        .filter((discountVoucher) => discountVoucher.unit === 'EUROS')
        .filter((discountVoucher) => !discountVoucher.usedByOrderId)
        .map((discountVoucher) => discountVoucher.value)
        .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
      : 0;
  }

  getClothes() {
    const { clothesProp, orderContext: { clothes } } = this.props;
    return clothesProp?.length > 0 ? clothesProp : clothes;
  }

  removePromoCode = () => {
    const { orderContext: { setPromoCode } } = this.props;
    setPromoCode({ code: '' });
    this.setState({
      promoCode: { code: '' },
      errorPromoCode: false,
    });
  };

  checkPromoCode(promoCode) {
    const { orderContext: { setPromoCode } } = this.props;
    const trimmedPromoCode = promoCode.trim();
    callApi(`public/checkPromoCode/${encodeURIComponent(trimmedPromoCode)}`)
      .then((res) => {
        pushToLayer({
          event: 'Order Funnel - Promo Code Added',
          promo_code: trimmedPromoCode,
        });
        setPromoCode(res.promoCode);
        this.setInputPromoCode(res.promoCode);
        this.setState({ errorPromoCode: false });
      })
      .catch(() => {
        this.setState({
          promoCode: { code: '' },
          errorPromoCode: true,
        });
      });
  }

  render() {
    if (typeof window === 'undefined') return null;
    const {
      selectedDates, vertical,
      onTotalPaid, hasZipcode, saveCloth, isAddingNewAddress,
      orderContext: {
        deleteCloth, trackTotalPaid, duplicateCloth, getOrderRequest,
      },
      isAdviceOrder, selectedAddress, lastStep, isSelectingDone, displayButtons,
      addPiece, setIsOrderSummaryModalOpened, goNext,
    } = this.props;
    const clothesState = this.getClothes();
    const { promoCode: promoCodeState } = this.state;
    const { hasPromoCode, errorPromoCode, isPromoCodeDisplayed } = this.state;
    // orderShort to display pieces in summary in short
    const orderShort = getOrderRequest(clothesState, { keepShort: true });
    // orderLong to compute right the totals
    const orderLong = getOrderRequest(clothesState);
    // orderWithoutDeliveryFee for total estimated in summary pop up
    const orderWithoutDeliveryFee = getOrderRequest(clothesState, { noDeliveryFee: true });
    const formattedClothes = this.getFormattedClothes(orderShort);
    const total = Math.round(getTotal(orderLong));
    const totalPaid = getTotalPaid(orderLong);
    const totalPaidStep1 = getTotalPaid(orderWithoutDeliveryFee);
    const totalPaidBrand = Math.round(getTotalPaidBrand(orderLong));
    const orderLongWithoutRepairBonus = getOrderRequest(clothesState, { withoutRepairBonus: true });
    const repairBonus = getTotalPaid(orderLongWithoutRepairBonus) - getTotalPaid(orderLong);
    const totalClothes = Math.round(getTotalClothes(orderLong) - repairBonus);
    const minOrderAmountFee = getMinOrderAmountFee(orderLong);
    const hasDefinedPrice = formattedClothes.reduce((acc, cloth) => acc || cloth.total !== 0, false);
    return (
      <OrderSummary
        totalPaidStep1={totalPaidStep1}
        rawClothes={clothesState}
        total={total}
        totalPaid={totalPaid}
        totalPaidBrand={totalPaidBrand}
        totalClothes={totalClothes}
        repairBonus={repairBonus}
        minOrderAmountFee={minOrderAmountFee}
        minOrderAmount={orderLong.minOrderAmount}
        selectedDates={selectedDates}
        vertical={vertical}
        clothes={formattedClothes}
        hasPromoCode={hasPromoCode}
        errorPromoCode={errorPromoCode}
        setHasPromoCode={this.setHasPromoCode}
        checkPromoCode={this.checkPromoCode}
        removePromoCode={this.removePromoCode}
        promoCode={promoCodeState}
        setInputPromoCode={this.setInputPromoCode}
        setEditingClothIndex={this.setEditingClothIndex}
        deleteCloth={deleteCloth}
        hasDefinedPrice={hasDefinedPrice}
        discountVouchersValue={this.getDiscountVouchers()}
        hasZipcode={hasZipcode}
        isPromoCodeDisplayed={isPromoCodeDisplayed}
        trackTotalPaid={trackTotalPaid}
        onTotalPaid={onTotalPaid}
        saveCloth={saveCloth}
        duplicateCloth={duplicateCloth}
        isAdviceOrder={isAdviceOrder}
        selectedAddress={selectedAddress}
        lastStep={lastStep}
        isAddingNewAddress={isAddingNewAddress}
        isSelectingDone={isSelectingDone}
        displayButtons={displayButtons}
        addPiece={addPiece}
        setIsOrderSummaryModalOpened={setIsOrderSummaryModalOpened}
        goNext={goNext}
      />
    );
  }
}

OrderSummaryContainer.propTypes = {
  clothesProp: PropTypes.arrayOf(PropTypes.shape({
    selectedCloth: PropTypes.string.isRequired,
    selectedLining: PropTypes.string.isRequired,
    selectedProblems: PropTypes.shape({}),
    selectedFabric: PropTypes.string.isRequired,
    selectedTypeOfWork: PropTypes.string.isRequired,
  })),
  selectedDates: PropTypes.shape({}),
  selectedAddress: PropTypes.shape({}),
  vertical: PropTypes.bool,
  orderContext: PropTypes.shape({
    setEditingClothIndex: PropTypes.func,
    trackTotalPaid: PropTypes.func,
    deleteCloth: PropTypes.func,
    duplicateCloth: PropTypes.func,
    discounts: PropTypes.arrayOf(PropTypes.shape({})),
    promoCode: PropTypes.shape({
      code: PropTypes.string,
      brand: PropTypes.shape({}),
    }),
    addOrEditCloth: PropTypes.func.isRequired,
    setPromoCode: PropTypes.func.isRequired,
    country: PropTypes.shape({}),
    getMinOrderAmount: PropTypes.func,
    transporter: PropTypes.string,
    deliveryFee: PropTypes.shape({}),
    getOrderRequest: PropTypes.func,
    clothes: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  customerContext: PropTypes.shape({
    customer: PropTypes.shape({
      discountVouchers: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }).isRequired,
  saveCloth: PropTypes.func,
  setEditingCloth: PropTypes.func,
  onTotalPaid: PropTypes.func,
  hasZipcode: PropTypes.bool,
  preFilledStep: PropTypes.shape({
    preFilledCloth: PropTypes.string,
    promoCode: PropTypes.string,
  }),
  isAdviceOrder: PropTypes.bool,
  closeModal: PropTypes.func,
  lastStep: PropTypes.bool,
  isAddingNewAddress: PropTypes.bool,
  isSelectingDone: PropTypes.bool,
  displayButtons: PropTypes.bool,
  addPiece: PropTypes.func,
  setIsOrderSummaryModalOpened: PropTypes.func,
  goNext: PropTypes.func,
  t: PropTypes.func.isRequired,
};

OrderSummaryContainer.defaultProps = {
  clothesProp: [],
  selectedDates: null,
  selectedAddress: null,
  vertical: false,
  saveCloth: () => { },
  setEditingCloth: () => { },
  onTotalPaid: () => { },
  hasZipcode: false,
  preFilledStep: undefined,
  isAdviceOrder: false,
  closeModal: () => { },
  lastStep: false,
  isAddingNewAddress: false,
  isSelectingDone: false,
  displayButtons: false,
  addPiece: () => { },
  setIsOrderSummaryModalOpened: () => { },
  goNext: () => { },
};

export default withNavigation(
  withTranslation()(
    withCustomerContext(
      withOrderContext(OrderSummaryContainer),
    ),
  ),
);
